import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { NotifyEmailModifyRequest } from "./NotifyEmailModifyRequest";

@Injectable()
export class DataService_MultiStationNotification {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	VisitorFacilitySelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorFacilitySelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	NotificationByRoleSelectList(FacilityID, EmailTypeID) {
		var postResult$ = new Subject();
		var url = "MultiStation/NotificationByRoleSelectList?FacilityID=" + FacilityID + "&EmailTypeID=" + EmailTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	NotificationInsert(parms: NotifyEmailModifyRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/NotificationInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	NotificationUpdate(parms: NotifyEmailModifyRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/NotificationUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	NotificationDelete(NotifyEmailID, FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/NotificationDelete?NotifyEmailID=" + NotifyEmailID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	NotificationFacilitySelectList(NotifyEmailID) {
		var postResult$ = new Subject();
		var url = "MultiStation/NotificationFacilitySelectList?NotifyEmailID=" + NotifyEmailID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
